import * as yup from 'yup';

export const reenrollmentFormSchema = yup.object({
  schoolAccountSfid: yup.string().required('Please select a school'),
  referrer: yup.string().required(),
});
